"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.throwMsg = exports.throwIt = exports.catchIt = void 0;

var _variant = require("./variant");

const catchIt = fn => {
  return (...args) => {
    try {
      return ["ok", fn(...args)];
    } catch (e) {
      return ["error", e];
    }
  };
};

exports.catchIt = catchIt;

const throwIt = fn => {
  return (...args) => {
    const res = fn(...args);

    if (_variant.V.type(res) === "error") {
      throw _variant.V.value(res);
    } else {
      return _variant.V.value(res);
    }
  };
};

exports.throwIt = throwIt;

const throwMsg = msg => {
  throw new Error(msg);
};

exports.throwMsg = throwMsg;
//# sourceMappingURL=uncatch.js.map